import React from 'react';

import Icon from '../Icon';
import useGameLogo from './useGameLogo';

import './gameLogo.scss';

interface Props {
    gameId: string;
}

const GameLogo: React.FC<Props> = ({ gameId }) => {
    const { glyph } = useGameLogo({
        gameId,
    });

    if (!glyph) return <div styleName="game" className="__app-GameLogo" />;

    return <Icon styleName="game" className="__app-GameLogo" glyph={glyph} />;
};

export default GameLogo;
